import React, { useCallback, useState } from 'react';

const KEYS = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
  ['*', '0', '#'],
];

const SUB_LABELS = {
  '1': '',
  '2': 'ABC',
  '3': 'DEF',
  '4': 'GHI',
  '5': 'JKL',
  '6': 'MNO',
  '7': 'PQRS',
  '8': 'TUV',
  '9': 'WXYZ',
  '*': '',
  '0': '+',
  '#': '',
};

function CallIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}

/** pointerdown so the last digit is committed before Call; preventDefault
 *  suppresses the following click so we do not double-fire. Mouse still
 *  registers because desktop fires pointerdown. */
function DialButton({ className, disabled, onActivate, ariaLabel, title, children }) {
  const [pressed, setPressed] = useState(false);
  const onPointerDown = useCallback((e) => {
    if (disabled) return;
    if (typeof e.button === 'number' && e.button !== 0) return;
    e.preventDefault();
    setPressed(true);
    onActivate(e);
  }, [disabled, onActivate]);
  const clearPressed = useCallback(() => setPressed(false), []);
  return (
    <button
      type="button"
      className={`${className}${pressed ? ' is-pressed' : ''}`}
      disabled={disabled}
      aria-label={ariaLabel}
      title={title}
      onPointerDown={onPointerDown}
      onPointerUp={clearPressed}
      onPointerCancel={clearPressed}
      onPointerLeave={clearPressed}
      onContextMenu={(e) => e.preventDefault()}
    >
      {children}
    </button>
  );
}

export default function Dialpad({ onDigit, onCall, callDisabled, onBackspace, hideCallButton }) {
  return (
    <div className="dialpad truva-glass-primary">
      {KEYS.map((row, ri) => (
        <div key={ri} className="dialpad-row">
          {row.map((key) => (
            <DialButton
              key={key}
              className="dialpad-key"
              onActivate={() => onDigit(key)}
              ariaLabel={`Digit ${key}`}
            >
              <span className="key-main">{key}</span>
              <span className="key-sub">{SUB_LABELS[key]}</span>
            </DialButton>
          ))}
        </div>
      ))}

      {/* 3-button action row: +, Call, Backspace */}
      <div className="dialpad-actions">
        <DialButton
          className="dialpad-action-btn"
          onActivate={() => onDigit('+')}
          ariaLabel="Insert plus"
          title="Add + prefix"
        >
          <span className="key-main">+</span>
        </DialButton>
        {hideCallButton ? (
          <div className="call-fab-spacer" aria-hidden="true" />
        ) : onCall ? (
          <DialButton
            className="call-fab"
            onActivate={() => onCall()}
            disabled={callDisabled}
            ariaLabel="Call"
          >
            <CallIcon />
          </DialButton>
        ) : (
          <button type="button" className="call-fab" disabled aria-label="Call disabled">
            <CallIcon />
          </button>
        )}
        {onBackspace && (
          <DialButton
            className="dialpad-action-btn"
            onActivate={onBackspace}
            ariaLabel="Backspace"
          >
            <span className="key-main">⌫</span>
          </DialButton>
        )}
      </div>
    </div>
  );
}
